export enum Extension {
  Jpeg = "image/jpeg",
  Jpg = "image/jpg",
  Png = "image/png"
}